import React, { useEffect } from 'react';
import { EventSearchBody } from '../constants/search';

const INITIAL_QUERY: EventSearchBody = {
    page_size: 8,
    aggs: {
        tags: { size: 50 },
        organizertagsautocomplete_agg: { size: 50 },
        dates: {},
    },
    dates: 'current_future',
};

interface SearchProviderShape {
    query: EventSearchBody;
    setQuery?: (newQuery: EventSearchBody) => void;
}

export const useSearchContext = () => {
    const value = React.useContext(SearchContext);

    if (value === undefined) {
        throw new Error('useSearchContext must be used within SearchProvider');
    }

    return value;
};

const SearchContext = React.createContext<SearchProviderShape>({
    query: INITIAL_QUERY,
});

export const SearchProvider: React.FunctionComponent<{
    initialQuery: EventSearchBody;
}> = (props) => {
    const { initialQuery } = props;
    const [query, setQuery] = React.useState<EventSearchBody>(
        props.initialQuery
            ? { ...INITIAL_QUERY, ...props.initialQuery }
            : INITIAL_QUERY,
    );

    const handleSetQuery = React.useCallback((newQuery: EventSearchBody) => {
        setQuery((currentQuery) => ({ ...currentQuery, ...newQuery }));
    }, []);

    useEffect(() => {
        handleSetQuery(initialQuery);
    }, [initialQuery, handleSetQuery]);

    return (
        <SearchContext.Provider value={{ query, setQuery: handleSetQuery }}>
            {props.children}
        </SearchContext.Provider>
    );
};

export default SearchProvider;
